module.exports = __webpack_public_path__ + "static/media/emsd0831_logo.98e57f92.jpg";